import { useLocation } from "react-router-dom";

export const Print = () => {
 const location = useLocation();
 const Person = location.state;
 console.log(Person);
 return <div>Print page</div>;
};
